import { NOT_APPLICABLE_LABEL, REVIEW_STATUS } from 'utils/constants';
import { getShippingPrice } from 'utils/helpers/shipping';

//Can add additional pricing logic here if needed
export const formatPrice = (price) => {
  return `$${price.toFixed(2)}`;
};

export const getItemPrice = (item) => {
  return item.extendedSellPrice || item.price || item.initialPrice || 0;
};

export const getItemPriceDisplay = (item, formatPrice, itemCurrency) =>
  item.status === REVIEW_STATUS
    ? NOT_APPLICABLE_LABEL
    : formatPrice(getItemPrice(item), itemCurrency);

export const getItemsPrice = (items) =>
  items.reduce((total, item) => total + getItemPrice(item), 0);

export const getTotalCasePrice = (items, shippingMethod, billToAddress, conversionRate) => {
  const itemsPrice = getItemsPrice(items);
  const shippingPrice =
    getShippingPrice(shippingMethod, billToAddress, conversionRate) * items.length;

  return itemsPrice + shippingPrice;
};

export const isNumber = (value) => typeof value === 'number';
